export const isEmptyTableValue = (value: unknown): boolean => {
  if (value == null) return true;
  if (typeof value !== 'string' && typeof value !== 'number') return false;
  const normalized = String(value).trim();
  return normalized === '' || normalized === 'N/A' || normalized === '-' || normalized === '-';
};

export const dataTableValueClassName = (value: unknown) =>
  isEmptyTableValue(value) ? 'text-gray-500' : 'text-gray-200';
